import { render } from "./ConsentDisclaimer.vue?vue&type=template&id=a034436c&scoped=true"
import script from "./ConsentDisclaimer.vue?vue&type=script&lang=js"
export * from "./ConsentDisclaimer.vue?vue&type=script&lang=js"

import "./ConsentDisclaimer.vue?vue&type=style&index=0&id=a034436c&lang=scss&scoped=true"

import exportComponent from "/Users/documedias/gitlab/virtuell/unionconf2025/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a034436c"]])

export default __exports__